// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : parts for domain and instance configuration
// =============================================================================
export const parts = true
export const templates = true
export const dashpanels = true

import * as views from './views'
export {views}

export {sagas} from './sagas'

import * as actions from './actions'
export {actions}

import * as reducers from './reducers'
export {reducers}
